import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Navigation</h3>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/quizz">Quiz</Link></li>
            <li><Link to="/learn">Apprendre</Link></li>
            <li><Link to="/account">Compte</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Support</h3>
          <ul>
            <li><a href="/faq">FAQ</a></li>
            <li><a href="/contact">Contactez-nous</a></li>
            <li><a href="/terms">Conditions d'utilisation</a></li>
            <li><a href="/privacy">Politique de confidentialité</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>À propos</h3>
          <p>Une plateforme pour apprendre et s'améliorer chaque jour.</p>
          <p>&copy; {new Date().getFullYear()} DWAG. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;